import type { ReactElement } from "react";
import { memo } from "react";

import type { TIconProps } from "../types";

const MicrosoftBookingsComponent = (props: TIconProps): ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fill="hsl(from hsl(181 96% 25%) h s 30%)"
        d="M11,1H7A1,1,0,0,0,6,2V22a1,1,0,0,0,1,1h4Z"
      />
      <path
        fill="hsl(from hsl(181 96% 25%) h s 39%)"
        d="M15,1H11a1,1,0,0,0-1,1V22a1,1,0,0,0,1,1h4Z"
      />
      <rect fill="none" width="24" height="24" />
      <rect
        fill="hsl(from hsl(181 96% 25%) h s 52%)"
        x="14"
        y="1"
        width="10"
        height="22"
        rx="1"
      />
      <rect
        fill="hsl(from hsl(181 96% 25%) h s 69%)"
        x="14"
        y="8"
        width="10"
        height="8"
      />
      <path
        opacity="0.5"
        d="M13.83,6H6V20h7.6A1.5,1.5,0,0,0,15,18.65V7.17A1.17,1.17,0,0,0,13.83,6Z"
        fill="black"
      />
      <rect
        fill="hsl(from hsl(181 96% 25%) h s 30%)"
        y="5"
        width="14"
        height="14"
        rx="1.17"
      />
      <path
        fill="white"
        d="M8.37,8.23a2,2,0,0,1,.91.65,1.57,1.57,0,0,1,.32,1A1.76,1.76,0,0,1,9.19,11a2.09,2.09,0,0,1-1.09.7v0a2.27,2.27,0,0,1,1,.32,1.84,1.84,0,0,1,.65.68,1.89,1.89,0,0,1,.23.93,2.17,2.17,0,0,1-.36,1.23,2.33,2.33,0,0,1-1,.82A3.73,3.73,0,0,1,7.05,16h-3V8H7A4,4,0,0,1,8.37,8.23ZM6.62,11.29a1.49,1.49,0,0,0,1-.3A1.06,1.06,0,0,0,8,10.15c0-.63-.44-1-1.34-1h-1v2.09Zm-1,3.52H6.84a1.65,1.65,0,0,0,1.07-.32,1.08,1.08,0,0,0,.38-.87,1,1,0,0,0-.39-.84,1.83,1.83,0,0,0-1.13-.29H5.62Z"
      />
    </g>
  </svg>
);

// NOTE: Memoized per the repo's mandatory-memoization rule for exported
// components. These icons re-render on every parent render otherwise, and their
// props (className, aria-*) are stable across almost all of them.
export const MicrosoftBookings = memo(MicrosoftBookingsComponent);
